/**
 * 删除套餐组后应选中的 Tab 下标。
 * 规则：删当前组优先落到前一项，否则落到下一项（同下标）；允许删光（返回 0，由 UI 展示空态）。
 * @param activeIdx - 当前选中下标
 * @param removeIdx - 被删除组下标
 * @param lengthAfterRemove - 删除后剩余组数量
 * @returns 删除后应选中的下标（无组时为 0）
 */
export function resolveActiveIdxAfterCourseGroupRemove(
    activeIdx: number,
    removeIdx: number,
    lengthAfterRemove: number,
): number {
    if (lengthAfterRemove <= 0) {
        return 0;
    }
    // 删掉当前之前的组：选中下标左移
    if (removeIdx < activeIdx) {
        return Math.min(activeIdx - 1, lengthAfterRemove - 1);
    }
    // 删掉当前组：优先前一项，否则保持 0（原下一项顶上来）
    if (removeIdx === activeIdx) {
        const preferred = removeIdx > 0 ? removeIdx - 1 : 0;
        return Math.min(preferred, lengthAfterRemove - 1);
    }
    // 删掉当前之后的组：选中不变
    return Math.min(activeIdx, lengthAfterRemove - 1);
}
